import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../spinner/ducks';
import { normalizeString } from '../../../common/utils/helpers';
import { HolidaysList } from '../components';
import { apiCallIds } from '../api';
import {
  fetchHolidaysActions,
  selectHolidays,
  selectHolidaysFilter,
  selectHolidaysPagination,
  setHolidaysFilterAction
} from '../ducks';
import Spin from 'antd/lib/spin';

const mapStateToProps = state => ({
  holidays: selectHolidays(state),
  filter: selectHolidaysFilter(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_EMAIL_LOGS),
  pagination: selectHolidaysPagination(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchHolidays: fetchHolidaysActions.request,
      setFilter: setHolidaysFilterAction,
    },
    dispatch
  ),
});

const defaultFilter = {
  search: '',
  sentDateStart: '',
  sentDateEnd: ''
};

@connect(mapStateToProps, mapDispatchToProps)
export default class HolidaysListContainer extends Component {
  static propTypes = {
    actions: PropTypes.object,
  };

  componentDidMount() {
    const { actions } = this.props;
    actions.setFilter(defaultFilter);
    actions.fetchHolidays(defaultFilter);
  }

  handleTableChange = (pagination, filters, sorter) => {
    const { actions, filter } = this.props;
    actions.fetchHolidays({
      ...filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
    });
  };


  onFilterDateRangeChange = ([dateFrom, dateTo]) => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      sentDateStart: dateFrom ? dateFrom.startOf('day').toISOString() : "",
      sentDateEnd: dateTo ? dateTo.endOf('day').toISOString() : ""
    })
  };

  onFilterSearchChange = filterValue => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      search: normalizeString(filterValue)
    });
  };

  render() {
    const { holidays, filter, isLoading, pagination } = this.props;

    return (<div>
      {!holidays ?
        <Spin className="dasboard-spinner" spinning={!holidays}>
          <div className="dashboard-spinner-message">{"Prebieha načítavanie sviatkov"}</div>
        </Spin> :

        <HolidaysList
          holidays={holidays}
          filter={filter}
          isLoading={isLoading}
          onFilterSearchChange={this.onFilterSearchChange}
          onFilterDateRangeChange={this.onFilterDateRangeChange}
          onTableChange={this.handleTableChange}
          pagination={pagination}
        />}
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/containers/HolidaysListContainer.js